import React from 'react';
import './barraNavegacion.css';



function BarraNavegacion({ componenteActivo, setComponenteActivo, salonSeleccionado, setSalonSeleccionado }) {
  
  
  
  return (
    <nav className="navbar navbar-expand-lg navbar-custom">
      <div className="container-fluid d-flex align-items-center justify-content-between">
        <span className="navbar-brand text-white" id="logo">
          Flash Estilistas
        </span>

        <div className="salon-buttons">
          <button
            className={`salon-button ${salonSeleccionado === 1 ? 'active' : ''}`}
            onClick={() => setSalonSeleccionado(1)}
          >
            SALÓN 1
          </button>
          <button
            className={`salon-button ${salonSeleccionado === 2 ? 'active' : ''}`}
            onClick={() => setSalonSeleccionado(2)}
          >
            SALÓN 2
          </button>
        </div>

        <div className="d-flex nav-buttons-container">
          <button
            className={`nav-button ${componenteActivo === 'principal' ? 'active' : ''}`}
            onClick={() => setComponenteActivo('principal')}
          >
            Principal
          </button>
          <button
            className={`nav-button ${componenteActivo === 'usuarios' ? 'active' : ''}`}
            onClick={() => setComponenteActivo('usuarios')}
          >
            Usuarios
          </button>
          <button
            className={`nav-button ${componenteActivo === 'contabilidad' ? 'active' : ''}`}
            onClick={() => setComponenteActivo('contabilidad')}
          >
            Contabilidad
          </button>
          <button
            className={`nav-button ${componenteActivo === 'inventario' ? 'active' : ''}`}
            onClick={() => setComponenteActivo('inventario')}
          >
            Inventario
          </button>
          <button
            className={`nav-button ${componenteActivo === 'personal' ? 'active' : ''}`}
            onClick={() => setComponenteActivo('personal')}
          >
            Personal
          </button>
        </div>
      </div>
    </nav>
  );
}

export default BarraNavegacion;
